import React from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { CSVLink } from "react-csv";

export const CustomToolbar = ({
    selectedData,
    exportBtn = false,
    fileName,
    setShowCreateModal,
    expandAll,
    collapseAll,
    hideLeftToolbar,
    ...rest
}) => {

    const route = window.location.href.split("/").pop();
    const date = new Date().toISOString();

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button 
                        label="New" 
                        icon="pi pi-plus" 
                        className="p-button-success mr-2" 
                        onClick={() => {
                            setShowCreateModal(true)
                        }}
                    />
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            
            <React.Fragment>
                {
                    expandAll && (
                        <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} text />
                    )
                }
                                {
                    collapseAll && (
                        <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} text />
                    )
                }
                {
                    exportBtn && (
                    <CSVLink asyncOnClick={true} data={selectedData} filename={`${fileName || route} report-${date.split("T")[0]}`}>
                        <Button label="Export" icon="pi pi-download" className="p-button-help" />
                    </CSVLink>
                    )
                }
            </React.Fragment>
        );
    };


    return (
        <>
        {
            hideLeftToolbar ? <Toolbar className="mb-4" right={rightToolbarTemplate}/> : 
            <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}/>
        }
        </>
    );
};